<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation #mainNavigation
                          class="dark bg-[#0f172a] print:hidden text-slate-300"
                          [mode]="isScreenSmall ? 'over' : 'side'"
                          [name]="'mainNavigation'"
                          [opened]="navigationOpened"
                          (openedChanged)="onNavigationOpenedChanged($event)">
    <!-- Sticky Navigation header hook -->
    <ng-container fuseVerticalNavigationHeader>
        <div class="flex h-16 items-center px-4 border-b border-white/10 relative"
             [ngClass]="{'justify-between': navigationOpened, 'justify-center': !navigationOpened}">
            @if (navigationOpened) {
            <div class="flex items-center min-w-0 gap-3">
                <img class="h-8 w-auto flex-shrink-0"
                     src="images/logo/logo.svg"
                     alt="GAC Logo" />
                <div class="flex flex-col min-w-0">
                    <span class="text-white text-lg font-semibold tracking-tight truncate leading-tight">Marine Logistics</span>
                    <span class="text-slate-400 text-[10px] truncate leading-tight">Delivering your strategy</span>
                </div>
            </div>

            <button mat-icon-button
                    class="!w-7 !h-7 !min-w-7 !p-0 rounded-lg border border-white/20 bg-white/10 hover:bg-white/20 hover:border-white shadow-sm flex items-center justify-center transition-all cursor-pointer"
                    (click)="toggleNavigation('mainNavigation')"
                    matTooltip="Collapse menu">
                <mat-icon class="icon-size-3.5 text-white/90"
                          [svgIcon]="'heroicons_solid:chevron-double-left'"></mat-icon>
            </button>
            }

            @if (!navigationOpened) {
            <div class="flex items-center justify-center p-1">
                <img class="h-7 w-auto"
                     src="images/logo/logo.svg"
                     alt="GAC Logo" />
            </div>

            <!-- Floating carved-out toggle button on the right border of navbar -->
            <button mat-icon-button
                    class="absolute -right-3.5 top-1/2 -translate-y-1/2 z-50 !w-7 !h-7 !min-w-7 !p-0 rounded-lg border border-white/25 bg-[#1E293B] hover:bg-[#25334a] hover:border-white shadow-md flex items-center justify-center transition-all cursor-pointer"
                    (click)="toggleNavigation('mainNavigation')"
                    matTooltip="Expand menu">
                <mat-icon class="icon-size-3.5 text-white/90"
                          [svgIcon]="'heroicons_solid:chevron-double-right'"></mat-icon>
            </button>
            }
        </div>
    </ng-container>

    <!-- Sticky Navigation footer hook -->
    <ng-container fuseVerticalNavigationFooter>
        <div class="flex h-11 items-center px-3 border-t border-white/10 bg-transparent"
             [ngClass]="{'justify-between': navigationOpened, 'justify-center': !navigationOpened}">
            @if (navigationOpened) {
            <div class="flex items-center gap-2 min-w-0">
                <span class="w-2 h-2 rounded-full bg-emerald-500 flex-shrink-0"></span>
                <span class="text-slate-400 text-xs font-medium tracking-tight truncate">Marlog 2.0.0</span>
            </div>
            }
        </div>
    </ng-container>

</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div class="bg-card relative z-49 flex h-12 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden">
        <!-- Navigation toggle button -->
        <button mat-icon-button
                (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <router-outlet></router-outlet>

    <!-- Footer -->
    <div class="bg-card relative z-49 flex h-8 w-full flex-0 items-center justify-start border-t px-4 dark:bg-transparent  print:hidden">
        <span class="text-secondary font-medium">Marlog 2.0.0</span>
    </div>
</div>